import { GridCol, mixins, styled } from '@bob/library'

export type LeftSideProps = {
  url?: string | null
}

export const LeftSide = styled.div<LeftSideProps>`
  position: relative;
  height: 100%;
  ${mixins.media.max.desktop} {
    height: calc(100vw - 40px);
    max-height: 400px;
  }
  background: ${({ url }) =>
    url ? `url('${url}') center top no-repeat` : mixins.colors.grayLight};
  background-blend-mode: multiply;
  background-size: 100%;
  background-size: cover;
  display: flex;
`

export const LeftTextWrapper = styled.div<LeftSideProps>`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  ${mixins.padding(50)}
  background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.79) 100%);
`

export const LeftHeadline = styled.h1`
  ${mixins.typography.noColor.headlineLarge};
  color: ${mixins.colors.grayWhite};
  ${mixins.margin(0)}
`

export const RightSide = styled(GridCol)`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
`

export type RightSideProps = {
  numberOfItems: number
}

export const RightItem = styled.a<RightSideProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: ${mixins.colors.grayLight};
  position: relative;
  ${mixins.padding(20, 50)}
  width: 100%;
  min-height: ${({ numberOfItems }) => (numberOfItems === 3 ? 200 : 300)}px;
  &:not(:first-child) {
    ${mixins.margin.top(20)}
  }
  ${mixins.media.max.desktop} {
    ${mixins.margin.top(20)}
  }
`

export const RightHeadline = styled.h2`
  ${mixins.typography.headlineSmall}
  ${mixins.margin.top(0)}
  ${mixins.margin.bottom(0)}
`

export const LearnMoreButtonWrapper = styled.div`
  ${mixins.margin(30)}
`
